export const _adsState = state => state?.ads;
export const _baseState = state => state.base;
export const _filtersState = state => state.filters;
export const _homeState = state => state.home;
export const _authState = state => state.auth;
export const _msgState = state => state.msg;
export const _creditsState = state => state.credits;
export const _payments = state => state.payments;
